// zoomControl — Zoom +/− als Katalog-Modul (RIGHT_BOTTOM). Vorher direkt in ViewController.createZoomControls;
// jetzt eine `kind:'module'`-Group im MAP_UI_CONFIG, gebaut/entfernt über den MapUiReconciler (wie mapType/multiLocation).
//
// Verantwortung: NUR UI + Zoom-Aktion. Die Buttons sitzen in einem `topo2-btn-stack` (gleicher Rahmen wie das linke
// Tools-Menü). `.zoom add`/`.zoom reduce` bleiben als Verhaltens-/Sichtbarkeits-Hook (z.B. `#galleryOverlay .zoom`).
import { resolveControlPosition } from "../adapter/providerConstants.js";
import { str } from "../../i18n/str.js";
// topo2 Button-Basis (Buttons + Stack-Container). Co-located: reist mit dem Consumer; Vite dedupliziert.

// Zoom-Icons (+/−) im Linien-Stil der MapToolsMenu-Icons: currentColor → folgt der topo2-Button-Farbe.
const ICON_ZOOM_IN =
    '<svg viewBox="0 0 24 24" aria-hidden="true">'
    + '<g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">'
    + '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></g></svg>';
const ICON_ZOOM_OUT =
    '<svg viewBox="0 0 24 24" aria-hidden="true">'
    + '<line x1="5" y1="12" x2="19" y2="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

// Reine UI: Stack-Container mit + (oben) / − (unten). onZoom(difference) wird bei Klick gerufen.
export function createZoomControl({ onZoom }) {
    const container = document.createElement('div');
    container.className = 'topo-zoom-controls topo2-btn-stack';

    const makeButton = (variantClass, icon, label, difference) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'zoom ' + variantClass + ' topo2-btn topo2-btn--icon topo2-btn--outline';
        b.title = label;
        b.setAttribute('aria-label', label);
        b.innerHTML = icon;
        b.addEventListener('click', () => onZoom(difference));
        return b;
    };

    container.appendChild(makeButton('add', ICON_ZOOM_IN, str('MAP_ZOOM_IN'), 1));       // + oben
    container.appendChild(makeButton('reduce', ICON_ZOOM_OUT, str('MAP_ZOOM_OUT'), -1)); // − unten
    return container;
}

// Modul-Factory für den MapUiReconciler: baut den Stack, hängt ihn an RIGHT_BOTTOM, liefert Handle { attach, destroy }.
// attach() = idempotentes Re-Push nach Controls-Clear (Tiles-Reload); destroy() entfernt den Stack wieder.
export function createZoomControlModule({ map, google, position }) {
    const container = createZoomControl({
        onZoom: (difference) => {
            if (map && typeof map.getZoom === 'function') { map.setZoom(map.getZoom() + difference); }
        }
    });

    const pos = position !== undefined ? position : resolveControlPosition(google, 'RIGHT_BOTTOM');
    if (pos !== undefined) { map.controls[pos].push(container); }

    return {
        attach() {
            if (pos === undefined) { return; }
            const arr = map.controls[pos];
            if (!arr) { return; }
            for (let i = 0; i < arr.getLength(); i++) {
                if (arr.getAt(i) === container) { return; }
            }
            arr.push(container);
        },
        destroy() {
            if (pos === undefined) { return; }
            const arr = map.controls[pos];
            if (!arr) { return; }
            for (let i = arr.getLength() - 1; i >= 0; i--) {
                if (arr.getAt(i) === container) { arr.removeAt(i); }
            }
        }
    };
}
